import { ChangeDetectionStrategy, Component, Directive, input, ViewEncapsulation } from '@angular/core';

@Directive({
  selector: '[tiimeTimelineItemTitle]',
  exportAs: 'tiime-timeline-item-title',
  host: {
    class: 'tiime-timeline-item-title'
  }
})
export class TimelineItemTitleDirective {}

@Directive({
  selector: '[tiimeTimelineItemDate]',
  exportAs: 'tiime-timeline-item-date',
  host: {
    class: 'tiime-timeline-item-date'
  }
})
export class TimelineItemDateDirective {}

@Directive({
  selector: '[tiimeTimelineItemDescription]',
  exportAs: 'tiime-timeline-item-description',
  host: {
    class: 'tiime-timeline-item-description'
  }
})
export class TimelineItemDescriptionDirective {}

@Component({
  selector: 'tiime-timeline-item',
  templateUrl: './timeline-item.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'tiime-timeline-item'
  }
})
export class TimelineItemComponent {
  readonly color = input<string>('primary');
}

@Component({
  selector: 'tiime-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'tiime-timeline'
  }
})
export class TimelineComponent {}
